import { render } from "./Questions.vue?vue&type=template&id=cce04844&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"

import "./Questions.vue?vue&type=style&index=0&id=cce04844&scoped=true&lang=css"

import exportComponent from "/home/mateo/Documents/education/vue/fh-course/questions-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cce04844"]])

export default __exports__